import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NgxEditorService {

    constructor() { }

    handlePasteEvent(event: ClipboardEvent, value: string): string {
        event.preventDefault();
        return this.stripOutUnsupportedStyling(value);
    }

    handleProjectNotesPasteEvent(event: ClipboardEvent, content: string): string {
        event.preventDefault();
        return this.stripOutUnsupportedStylesProjectNotes(content);
    }

    stripOutUnsupportedStyling(value: string): string {
        const valueWithoutStyles: string = value.replace(/style="[^"]*"/g, '');
        const valueWithoutStylesAndImages: string = valueWithoutStyles.replace(/<img[^>]*>/g, '');
        const valueWithoutStylesAndImagesAndLinks: string = valueWithoutStylesAndImages.replace(/<a[^>]*>/g, '');
        return valueWithoutStylesAndImagesAndLinks;
    }

    stripOutUnsupportedStylesProjectNotes(value: string): string {
        const valueWithoutStyles: string = value.replace(/style="[^"]*"/g, '');
        return valueWithoutStyles;
    }
}
